<template>
  <CenterContent size="xs12 sm10 md4 lg4 xl4">
    <Panel :form="form" ref="panel" title="Welcome" description="Sign in your account" @onFormChange="onFormChange" :class-object="['px-5']">
      <Input outlined label="E-mail" :type="emailType" v-model="form.username" />
      <Input outlined label="Password" :type="passwordType" v-model="form.password" :min="5" :max="16" />
      <Alert :type="response.variant" :message="response.message" />
      <Button @onClick="onButtonClick" :loading="this.response.loading" title="Sign in" :class-object="['primary']" block text large></Button>
    </Panel>
  </CenterContent>
</template>

<script>
import Vue from "vue"
import { mapGetters } from 'vuex'
import CenterContent from "@/base_lib/components/container/CenterContent"
import Panel from "@/base_lib/components/container/Panel"
import Input from "@/base_lib/components/form/Input"
import Alert from "@/base_lib/components/view/Alert"
import Button from "@/base_lib/components/form/Button"
import pageMixin from "@/base_lib/data/mixins/pageMixin"
import AccountServices from "@/services/EditorServices"

export default {
  name: "Login.vue",
  components: {Button, Alert, Input, Panel, CenterContent},
  mixins: [pageMixin],
  data: () => ({
    form: {
      username: null,
      password: null,
    },
  }),
  computed: {
    ...mapGetters({
      token: "auth/token"
    }),
  },
  methods: {
    onButtonClick() {
      this.$refs.panel.validate()

      if (this.isFormValid) {
        // Clear flash message from URL and screen
        this.clearFlashMessage()
        
        this.response.loading = true
        AccountServices.login(this.form.username, this.form.password).then(response => {
          this.response = response.networkResponse(true, true)
          this.onSaveUser(response.data)
        }).catch(error => {
          this.response = error.networkError?.(error, true)
        })
      }
    },
    onSaveUser(response) {
      if (response.code !== 100) return

      // Clear retry storage before login
      const { clearAllRetryData } = require('@/util/retryStorage')
      clearAllRetryData()

      const account = {
        ...response.data.editor,
      }

      Vue.prototype.$stateManagement.dispatch('auth/login', { 
        account: account, 
        token: response.data.token 
      }).catch(error => {
        console.log(error)
        this.handleCustomError(error.toString())
      })
    },
    checkFlashMessage() {
      if (this.$route.query.flash) {
        this.response = {
          loading: false,
          code: 400,
          timestamp: new Date().getTime(),
          variant: 'error',
          message: this.$route.query.flash,
        }
      }
    },
    clearFlashMessage() {
      // Clear flash message from screen
      if (this.response.message && this.$route.query.flash) {
        this.response = {
          loading: false,
          code: null,
          timestamp: null,
          variant: null,
          message: null,
        }
      }
      
      // Clear flash message from URL
      if (this.$route.query.flash) {
        const query = { ...this.$route.query }
        delete query.flash
        this.$router.replace({ query }).catch(() => {})
      }
    },
  },
  watch: {
    '$route.query.flash': {
      immediate: false,
      handler() {
        this.checkFlashMessage()
      }
    }
  },
  mounted() {
    // Clear retry storage on logout
    const { clearAllRetryData } = require('@/util/retryStorage')
    clearAllRetryData()
    
    Vue.prototype.$stateManagement.dispatch('teams/logout')
    Vue.prototype.$stateManagement.dispatch('auth/logout')
    
    // Check for flash message from query params
    this.checkFlashMessage()
  }
}
</script>
